// @flow

import * as React from 'react';

import type { VenueResult } from 'search/types';

export default function ReviewCount({ venue }: { venue: VenueResult, ... }) {
  return (
    venue.reviews_count > 0 && (
      <span className="b-search-result__details-item">
        <i className="fa fa-comment-o" />
        &nbsp;
        {venue.reviews_count}
      </span>
    )
  );
}
